import { fn } from '@ember/helper';
import { on } from '@ember/modifier';
import { service } from '@ember/service';
import Component from '@glimmer/component';

import type { Service, VisualizationForList } from 'webapp-types';
import type { BlockVisualization } from 'webapp/enums/enums';

import eq from 'webapp/helpers/eq';
import CommonUiIconComponent from 'webapp/components/common/ui-icon';

interface Args {
	selected: BlockVisualization;
	onChange: (vis: BlockVisualization) => void;
	options?: VisualizationForList[];
}

export default class BlockSettingsVisualizationsGridComponent extends Component<Args> {
	@service('model-manager/blocks') declare mmBlocksService: Service.ModelManager.Blocks;

	get options(): VisualizationForList[] {
		return this.args.options ?? this.mmBlocksService.switchableVisualizationList;
	}
	<template>
		<ul class="bs__visualizations">

			{{#each this.options as |vis|}}
				<li
					class="bs__vis bs__vis--{{vis.id}}
						{{if (eq @selected vis.id) 'bs__vis--selected'}}"
				>
					{{#if vis.isNew}}
						<div class="new-feature-tag">New</div>
					{{/if}}
					<a {{on "click" (fn @onChange vis.id)}}>
						<CommonUiIconComponent @name={{vis.icon}} @size="lg" />
						{{vis.label}}
					</a>
				</li>
			{{/each}}

		</ul>
	</template>
}
